var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34286 4.09091C3.34286 1.83156 5.21371 0 7.52143 0C9.82915 0 11.7 1.83156 11.7 4.09091V12.2727C11.7 15.4358 9.08086 18 5.85 18C2.61913 18 0 15.4358 0 12.2727V5.65289C0 5.20102 0.374162 4.83471 0.835714 4.83471C1.29727 4.83471 1.67143 5.20102 1.67143 5.65289V12.2727C1.67143 14.5321 3.54224 16.3636 5.85 16.3636C8.15775 16.3636 10.0286 14.5321 10.0286 12.2727V4.09091C10.0286 2.73531 8.90606 1.63636 7.52143 1.63636C6.1368 1.63636 5.01429 2.73531 5.01429 4.09091V11.6033C5.01429 12.0552 5.38842 12.4215 5.85 12.4215C6.31158 12.4215 6.68571 12.0552 6.68571 11.6033V5.72727C6.68571 5.2754 7.05988 4.90909 7.52143 4.90909C7.98298 4.90909 8.35714 5.2754 8.35714 5.72727V11.6033C8.35714 12.9589 7.23468 14.0578 5.85 14.0578C4.46532 14.0578 3.34286 12.9589 3.34286 11.6033V4.09091Z",
    fill: "#2D4575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.5ed390a8672797414a3be83e1aaebee5.svg";
export { ForwardRef as ReactComponent };